import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function fetchDocumentConversationItems(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DC_DOCUMENT_CONVERSATION_ITEMS_FETCH,
    (
      organisationId,
      projectId,
      matterId,
      documentId,
      conversationId,
      conversationType,
      previousMessageId,
    ) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}` +
            `/matter/${matterId}` +
            `/document/${documentId}` +
            `/conversation/${conversationId}` +
            `/item/${previousMessageId ? previousMessageId : "start"}`,
          {withCredentials: true},
        )
        .then(response => ({
          conversation: {
            is_private: response.data.isPrivate,
            id: conversationId,
            items: response.data.items,
          },
          document_id: documentId,
          conversation_type: conversationType,
        })),
  );
}
